import { useTranslation } from 'react-i18next';
import styles from '../styles/userLoading.module.scss';
import { Button, PixelIllustrations } from '@abtasty/design-system';
import { useSegmentTrack } from '@src/application/hooks/useSegment/useSegment';

type ErrorForbiddenAccessProps = { message: string; onClick?: () => void };
export const ErrorForbiddenAccess = ({ message, onClick }: ErrorForbiddenAccessProps) => {
  const { t } = useTranslation();
  const segmentTrack = useSegmentTrack();
  return (
    <div className={styles.container}>
      <PixelIllustrations illustration="embarrassedMisterB" />
      <span className={styles.forbiddenText}>{message}</span>
      <span>{t(' Please contact an admin to get your access granted.')}</span>
      <a
        onClick={() => {
          segmentTrack(t('Qa mode - Click on login'));
          onClick && onClick();
        }}
      >
        <Button variant="outlined" label={t('Log in')} />
      </a>
    </div>
  );
};
